import { Model, Store, Casts } from 'store/Base';
import { observable } from 'mobx';
import { Subproject } from 'store/Subproject';
import { User } from 'store/User';

export const TICKET_STATUS_TODO = 'todo';
export const TICKET_STATUS_IN_PROGRESS = 'in_progress';
export const TICKET_STATUS_REVIEW = 'review';
export const TICKET_STATUS_DONE = 'done';
export const TICKET_STATUS_BLOCKED = 'blocked';
export const TICKET_STATUSES = [
    TICKET_STATUS_TODO,
    TICKET_STATUS_IN_PROGRESS,
    TICKET_STATUS_REVIEW,
    TICKET_STATUS_DONE,
    TICKET_STATUS_BLOCKED,
];

export class PlanningTicket extends Model {
    static backendResourceName = 'planning_ticket';

    @observable id = null;
    // [T54191] The milestone relation targets the unified Subproject model
    // (planning milestones ARE sub projects now).
    @observable milestone = this.relation(Subproject);
    @observable title = '';
    @observable description = '';
    // [T54255] Description rendered to HTML by Phabricator (remarkup.process)
    // server-side on every sync — sanitized with DOMPurify before injecting.
    @observable descriptionHtml = '';
    @observable estimatedHours = 0;
    @observable phabricatorTaskNumber: number | null = null;
    // [T54364] Workboard column on the sub project's Phabricator board
    @observable phabricatorColumn = '';
    @observable spentHours = 0;
    @observable scheduledStart = null;
    @observable scheduledEnd = null;
    @observable status = TICKET_STATUS_TODO;
    @observable assignee = this.relation(User);
    @observable order = 0;

    casts() {
        return {
            scheduledStart: Casts.date,
            scheduledEnd: Casts.date,
        };
    }
}

export class PlanningTicketStore extends Store {
    Model = PlanningTicket;
    static backendResourceName = 'planning_ticket';
}
